import { render } from "./Census.vue?vue&type=template&id=60ebd311"
import script from "./Census.vue?vue&type=script&lang=js"
export * from "./Census.vue?vue&type=script&lang=js"

import "./Census.vue?vue&type=style&index=0&id=60ebd311&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__